import { CellContext } from '@tanstack/react-table';

import { WebEDIRowData } from 'components/DataTable/Types';
import { useEnumerableOptions } from 'components/WebEDI/helpers';

import { CellProps } from '../../types';
import { DropdownCell } from './DropdownCell';

export type Props = CellContext<WebEDIRowData, unknown> & Omit<CellProps, 'register'>;

export const EnumerableCell = (props: Props) => {
  const {
    column: {
      columnDef: { meta },
    },
  } = props;
  const { options } = useEnumerableOptions(meta?.optionalConfig);

  return <DropdownCell {...props} options={options} />;
};
